import { render, staticRenderFns } from "./regular-filter-selector.component.vue?vue&type=template&id=0fb8d6e8&scoped=true"
import script from "./regular-filter-selector.component.vue?vue&type=script&lang=ts"
export * from "./regular-filter-selector.component.vue?vue&type=script&lang=ts"
import style0 from "./regular-filter-selector.component.vue?vue&type=style&index=0&id=0fb8d6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8d6e8",
  null
  
)

export default component.exports